// @flow
/* eslint-disable no-inline-comments */
import imported from 'react-imported-component';

export const AppContextual = imported(() => import(/* webpackChunkName: "AppContextual-Index" */ './AppContextual'));
